import { Button } from '@mui/material'
import { useAuthContext } from 'components/context/AuthProvider'
import { UIModal } from 'features/UI'
import { useShowControl } from 'hooks/useShowControl'
import React from 'react'
import { ArticleType } from 'types'
import { ArticleShareForm } from './ArticleShareForm'

export function ArticleControlShare({
  entityId,
  entityType,
}: {
  entityId: number
  entityType: ArticleType | 'note'
}) {
  const { isSharingEnabled } = useAuthContext()

  const [isOpen, handleOpen, handleClose] = useShowControl()

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        disabled={!isSharingEnabled}
        onClick={handleOpen}
      >
        Share
      </Button>

      <UIModal title="Share this article" width={580} isOpen={isOpen} onClose={handleClose}>
        <ArticleShareForm entityId={entityId} entityType={entityType} onClose={handleClose} />
      </UIModal>
    </>
  )
}
